export const filesize = (fileSize: number) => {
   let size = Math.ceil(fileSize / 1024)
   if (size === 0) {
      return ' '
   } else if (size < 1024) {
      return size + ' kB'
   } else {
      size = Math.ceil(size / 1024)
      return size + ' MB'
   }
}
